import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "row", "hint", "destroyFlag", "positionField", "priceField"]

  add() {
    const index = new Date().getTime()
    const html = this.templateTarget.innerHTML.replace(/NEW_INDEX/g, index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.updatePositions()
    this.showHint()
  }

  remove(event) {
    const row = event.target.closest("[data-variants-form-target='row']")
    const destroyFlag = row.querySelector("[data-variants-form-target='destroyFlag']")

    if (destroyFlag && destroyFlag.name.includes("[id]") === false) {
      // 既存レコードは_destroyフラグを立てて非表示に
      const idField = row.querySelector("input[name*='[id]']")
      if (idField && idField.value) {
        destroyFlag.value = "true"
        row.style.display = "none"
      } else {
        row.remove()
      }
    } else {
      row.remove()
    }

    this.updatePositions()
    this.toggleHint()
  }

  updatePositions() {
    this.rowTargets.forEach((row, i) => {
      if (row.style.display === "none") return
      const posField = row.querySelector("[data-variants-form-target='positionField']")
      if (posField) posField.value = i
    })
  }

  showHint() {
    if (this.hasHintTarget) this.hintTarget.classList.remove("hidden")
  }

  toggleHint() {
    if (!this.hasHintTarget) return
    const visibleRows = this.rowTargets.filter(r => r.style.display !== "none")
    if (visibleRows.length === 0) {
      this.hintTarget.classList.add("hidden")
    } else {
      this.hintTarget.classList.remove("hidden")
    }
  }
}
